import type { ExcelGridKeyboardMovement } from "../models/excel-grid.models";

export const DEFAULT_VIRTUALIZED_ROW_HEIGHT = 34;

const GRID_HEADER_WITH_FILTERS_HEIGHT = 64;
const GRID_SCROLLBAR_HEIGHT_ALLOWANCE = 16;
const VIRTUALIZED_GRID_HEIGHT_CLASS_NAMES: Record<number, string> = {
  500: "excel-grid-virtualized-height-500",
  560: "excel-grid-virtualized-height-560",
  600: "excel-grid-virtualized-height-600",
  650: "excel-grid-virtualized-height-650",
};
const ROW_HEIGHT_CLASS_NAMES: Record<number, string> = {
  28: "excel-grid-row-height-28",
  34: "excel-grid-row-height-34",
  38: "excel-grid-row-height-38",
  48: "excel-grid-row-height-48",
};

export const getKeyboardMovement = (key: string, shiftKey: boolean): ExcelGridKeyboardMovement | null => {
  if (key === "ArrowUp") return { row: -1, column: 0 };
  if (key === "ArrowDown") return { row: 1, column: 0 };
  if (key === "ArrowLeft") return { row: 0, column: -1 };
  if (key === "ArrowRight") return { row: 0, column: 1 };
  if (key === "Tab") return { row: 0, column: shiftKey ? -1 : 1 };

  return null;
};

export const getGridCellHeightClassName = (rowHeight: number | undefined): string => {
  if (rowHeight === undefined) {
    return "excel-grid-row-height-default";
  }

  return ROW_HEIGHT_CLASS_NAMES[rowHeight] ?? "excel-grid-row-height-default";
};

export const getVirtualizedGridHeightClassName = (virtualizedMaxHeight: number): string =>
  VIRTUALIZED_GRID_HEIGHT_CLASS_NAMES[virtualizedMaxHeight] ?? "excel-grid-virtualized-height-default";

export const getCellEditorRows = (value: string): number => Math.max(1, value.split(/\r\n|\r|\n/).length);

export const omitInlineStyleProp = <TProps extends object>(props: TProps): Omit<TProps, "style"> => {
  const propsWithoutInlineStyle = { ...props } as TProps & { [key: string]: unknown };
  delete propsWithoutInlineStyle["style"];

  return propsWithoutInlineStyle;
};

export const getEstimatedVirtualizedGridContentHeight = (rowCount: number, rowHeight: number | undefined): number => {
  const itemHeight = rowHeight ?? DEFAULT_VIRTUALIZED_ROW_HEIGHT;

  return rowCount * itemHeight + GRID_HEADER_WITH_FILTERS_HEIGHT + GRID_SCROLLBAR_HEIGHT_ALLOWANCE;
};

export function getActiveElementLabel(): string {
  const element = document.activeElement;
  if (!element) {
    return "none";
  }

  const tagName = element.tagName.toLowerCase();
  const dataTest = element.getAttribute("data-test");
  return dataTest ? `${tagName}[${dataTest}]` : tagName;
}
